import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';
import { ClientItemId } from 'owa-client-ids';
import { DateRange } from 'owa-datetime-utils';
import { EventsCacheLockId } from 'owa-events-cache';
import { fetchCalendarEventsForDateRange } from './fetchCalendarEventsForDateRange';
import { fetchFullCalendarEvent } from './fetchFullCalendarEvent';
import { LockedCalendarEventsStore } from '../../types/LockedCalendarEventsStore';
import { releaseEventsCacheLock } from '../../actions/eventsCacheActions';

export function getLockedCalendarEventsStore(lockId: EventsCacheLockId): LockedCalendarEventsStore {
    if (!lockId) {
        throw new Error('The lock id should be provided');
    }

    return {
        fetchCalendarEventsForDateRange: (
            folderId: string,
            dateRange: DateRange
        ): Promise<CalendarEvent[]> => {
            return fetchCalendarEventsForDateRange(lockId, folderId, dateRange);
        },
        fetchFullCalendarEvent: (
            eventId: ClientItemId,
            folderId?: string,
            getExistingCalendarEvent?: (eventId: ClientItemId) => CalendarEvent | null,
            eventScope?:
                | EventScope.Default
                | EventScope.ThisInstanceOnly
                | EventScope.AllInstancesInSeries
        ): { event: CalendarEvent; fullEventPromise: Promise<CalendarEvent> } => {
            return fetchFullCalendarEvent(
                lockId,
                eventId,
                folderId,
                getExistingCalendarEvent,
                eventScope
            );
        },
        getLockId: () => lockId,
        release: () => releaseEventsCacheLock(lockId),
    };
}
